import * as types from 'constants/actionTypes';
import * as operationsApi from 'api/operationsApi';
import { beginAjaxCall, ajaxCallError } from './ajaxCallActions.js';

export function getSizeOfContainers() {
  return function(dispatch) {
    dispatch(beginAjaxCall());
    return operationsApi
      .getSizeOfContainers()
      .then(
        response => dispatch(getSizeOfContainersSuccess(response)),
        error => dispatch(ajaxCallError())
      );
  };
}

function getSizeOfContainersSuccess(response) {
  return {
    type: types.GET_SIZE_OF_CONTAINERS_SUCCESS,
    sizeOfContainers: response.data || []
  };
}
